export class BaoProductFormSTL extends HTMLElement {
  constructor() {
    super()

    this.checkValidity()
    this.setupListeners()
  }

  checkValidity() {
    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  setupListeners() {
    this.form.addEventListener("submit", this.handleSubmit.bind(this))
  }

  async handleSubmit(evt) {
    evt.preventDefault()

    const submitButton = this.form.querySelector('[type="submit"]')

    if (submitButton?.getAttribute("aria-disabled") === "true") return

    const selectedOptions = Array.from(
      document.querySelectorAll('[data-product-form-el="select"] option:checked')
    ).filter((option) => option.value)

    if (!selectedOptions.length) {
      this.handleErrorMessage?.("Please select at least one size")
      return
    }

    this.handleErrorMessage?.()

    submitButton?.setAttribute("aria-disabled", "true")
    submitButton?.classList.add("loading")
    submitButton?.querySelector(".loading__spinner")?.classList.remove("hidden")

    const formData = new FormData()

    selectedOptions.forEach((option, index) => {
      formData.append(`items[${index}][id]`, option.value)
      formData.append(`items[${index}][quantity]`, "1")
    })

    const config = fetchConfig("javascript")
    config.headers["X-Requested-With"] = "XMLHttpRequest"
    delete config.headers["Content-Type"]
    config.body = formData

    try {
      const response = await fetch(`${routes.cart_add_url}`, config)
      const data = await response.json()

      if (data.status) {
        this.handleErrorMessage?.(data.description)
        return
      }

      window.location.href = window.routes?.cart_url || "/cart"
    } catch (error) {
      console.error(error)
    } finally {
      submitButton?.classList.remove("loading")
      submitButton?.querySelector(".loading__spinner")?.classList.add("hidden")
      submitButton?.removeAttribute("aria-disabled")
    }
  }

  get form() {
    return this.querySelector("form")
  }
}

if (!customElements.get("bao-product-form-shop-the-look")) {
  customElements.define("bao-product-form-shop-the-look", BaoProductFormSTL)
}
